var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PartnerHeader',{attrs:{"img_header":_vm.header_image,"header":"แก้ไขข่าวสารใหม่","link_back":"newsinformation"}}),_c('MenuPartner'),_c('News_edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }